import { Modal } from "@material-ui/core";
import { observer } from "mobx-react";
import appStore from "../../Config/Store/appStore";
import JsonTextArea from "../Common/JsonTextArea";
import "./CustomAttributeModal.scss";
import collapseIcon from "../../assets/images/close_fullscreen.svg";

const CustomAttributeModal = observer(
  ({ data, handlecustomAttributesChange, handleFormatJson, expandModal }) => {
    return (
      <>
        <Modal
          open={appStore.customAttrModal}
          onClose={() => {
            appStore.setCustomAttrModal(false);
          }}
          className="customAttributeModal"
        >
          <div className="customAttributeModalContainer">
            <div>
              <JsonTextArea
                placeholder="Enter custom attributes"
                label="Custom Attributes"
                className="customTextArea"
                name={"customAttributes"}
                customAttributes={data}
                handlecustomAttributesChange={handlecustomAttributesChange}
                handleFormatJson={handleFormatJson}
                expandModal={expandModal}
                icon={collapseIcon}
              />
            </div>
          </div>
        </Modal>
      </>
    );
  }
);

export default CustomAttributeModal;
